import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ModelConstants } from 'shell-models-lib';
import { ApiIntegrationActivity } from './api-integration.activity';

@Metamodel.model({
    name: ModelConstants.businessActionsActivity,
    referable: true
})
export class BusinessActionsActivity extends ApiIntegrationActivity {
    public static readonly MODEL: IModel;

    public override get isFabricServiceType(): boolean {
        return this.serviceType === 'Fabric';
    }
}
